import { render, staticRenderFns } from "./default-after-login-v2.vue?vue&type=template&id=e4922fb8&lang=pug"
import script from "./default-after-login-v2.vue?vue&type=script&lang=js"
export * from "./default-after-login-v2.vue?vue&type=script&lang=js"
import style0 from "./default-after-login-v2.vue?vue&type=style&index=0&id=e4922fb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports